import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const GraduationCap = createSvgIcon(
  <path d="M24 6.2 11.617 3.764 0 6.212v4.072l3 .643v6.789l8.625 2.544 8.625-2.544v-6.669l1.5-.3v9.503H24V6.2Zm-2.25 1.85v.403l-10.117 2.023-9.383-2.01v-.429l9.383-1.977L21.75 8.05ZM18 11.497v4.537l-6.375 1.88-6.375-1.88v-4.625l6.367 1.365L18 11.497Z" />,
  'GraduationCap'
);

export { GraduationCap };